// Compose — the three-column chat-with-doc surface (08_AUTHORING_APP.md):
// chat on the left, the post editor in the middle, drafts on the right.
// Initializes the compose store on mount; surfaces the API-key modal
// when the creator hasn't added a key yet.

import { useEffect, useState } from "react";
import { useAuthStore } from "../../store/authStore";
import { useComposeStore } from "../../store/composeStore";
import { useKeyStore } from "../../store/keyStore";
import { ChatPane } from "./ChatPane";
import { EditorPane } from "./EditorPane";
import { RightSidebar } from "./RightSidebar";
import { ApiKeyModal } from "../ApiKeyModal";

export function ComposeView() {
  const user = useAuthStore((s) => s.user)!;
  const loading = useComposeStore((s) => s.loading);
  const init = useComposeStore((s) => s.init);
  const canChat = useKeyStore((s) => s.canChat());
  const [keyModal, setKeyModal] = useState(false);

  useEffect(() => { void init(user.sub); }, [user.sub, init]);

  if (loading) {
    return <div className="cv-loading">opening your drafts…<Styles /></div>;
  }

  return (
    <div className="cv-root">
      {!canChat && (
        <button className="cv-keybanner" onClick={() => setKeyModal(true)}>
          Pick a writing model to start →
        </button>
      )}
      <div className="cv-cols">
        <div className="cv-chat"><ChatPane onNeedKey={() => setKeyModal(true)} /></div>
        <div className="cv-editor"><EditorPane /></div>
        <div className="cv-drafts"><RightSidebar /></div>
      </div>
      {keyModal && <ApiKeyModal onClose={() => setKeyModal(false)} />}
      <Styles />
    </div>
  );
}

function Styles() {
  return (
    <style>{`
      .cv-root { height: 100%; display: flex; flex-direction: column; min-height: 0; }
      .cv-keybanner {
        flex: none; text-align: center; width: 100%;
        font-family: var(--font-sans); font-size: 13px; font-weight: 600; color: var(--teal);
        background: var(--teal-dim); border: none; border-bottom: 1px solid var(--line);
        padding: 8px; cursor: pointer;
      }
      .cv-keybanner:hover { background: rgba(13,110,110,0.2); }
      .cv-cols { flex: 1; min-height: 0; display: grid; grid-template-columns: 340px 1fr 260px; }
      .cv-chat, .cv-editor, .cv-drafts { min-height: 0; min-width: 0; height: 100%; }
      .cv-loading {
        height: 100%; display: flex; align-items: center; justify-content: center;
        font-family: var(--font-mono); font-size: 12px; color: var(--ink-faint); font-style: italic;
      }
      @media (max-width: 1100px) {
        .cv-cols { grid-template-columns: 300px 1fr; }
        .cv-drafts { display: none; }
      }
    `}</style>
  );
}
